module.exports = __webpack_public_path__ + "img/construction_materials.37e6d7ab.jpg";